<payee-header>
  <ng-template #logoTemplate>
    <a
      [target]="'_blank'"
      [href]="payeeLink"
    >
      <img
        src="assets/shared/global-images/payee-logos/v1/black-payee-with-badge.svg"
        width="100px"
        alt="Payee"
      />
    </a>
  </ng-template>
  <ng-template #buttonTemplateRef>
    <payee-icon
      [name]="'gdpr'"
      [width]="'120px'"
      [height]="'48px'"
    ></payee-icon>
  </ng-template>

  <ng-template #payeeHeaderLogoTemplate>
    <ng-container [ngTemplateOutlet]="logoTemplateRef || logoTemplate"></ng-container>
  </ng-template>
  @if (buttonTemplateRef) {
    <ng-template #payeeHeaderButtonTemplate>
      <ng-container [ngTemplateOutlet]="buttonTemplateRef"></ng-container>
    </ng-template>
  }
  <ng-content></ng-content>
</payee-header>
